import { isUndefined } from '@polkadot/util';
function sig(_ref, _ref2, args) {
  let {
    lookup
  } = _ref;
  let {
    method,
    section
  } = _ref2;
  return "".concat(section, ".").concat(method, "(").concat(args.map(a => lookup.getTypeDef(a).type).join(', '), ")");
}
export function extractStorageArgs(registry, creator, _args) {
  const args = _args.filter(a => !isUndefined(a));
  if (creator.meta.type.isPlain) {
    if (args.length !== 0) {
      throw new Error("".concat(sig(registry, creator, []), " does not take any arguments, ").concat(args.length, " found"));
    }
  } else {
    const {
      hashers,
      key
    } = creator.meta.type.asMap;
    const keys = hashers.length === 1 ? [key] : registry.lookup.getSiType(key).def.asTuple.map(t => t);
    if (args.length !== keys.length) {
      throw new Error("".concat(sig(registry, creator, keys), " is a map, requiring ").concat(keys.length, " arguments, ").concat(args.length, " found"));
    }
  }
  // pass as tuple
  return [creator, args];
}